module.exports = __webpack_public_path__ + "static/media/instagram.00bae294.svg";